import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Icon from "module-common/Icon";

export default class Header extends Component {
  static propTypes = { onClick: PropTypes.func };

  render() {
    return (
      <Wrapper>
        <Title>INFO</Title>
        <Icon name="x-button-gray" onClick={this.props.onClick} />
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  flex: none;
  height: 45px;
  padding: 0 20px;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
`;
const Title = styled.span`
  color: ${props => props.theme.headerTitle};
`;



// WEBPACK FOOTER //
// ./src/module-case-management/info-panel/Header.js